import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  AuthService,
  BETALNINGSUPPGIFT_REMINDER_PENDING_KEY,
} from '@vinnova/auth';
import { ModalService } from '@vinnova/ui';
import { EMPTY, combineLatest, switchMap, take } from 'rxjs';
import { BetalningsuppgiftReminderModalComponent } from '../components/betalningsuppgift-reminder-modal/betalningsuppgift-reminder-modal.component';
import { environment } from '../environment';

@Injectable({
  providedIn: 'root',
})
export class BetalningsuppgiftReminderService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private modalService: ModalService,
    @Inject(environment) private env,
  ) {}

  public showBetalningsuppgiftReminderModal() {
    const paymentDetailsReminderPending = sessionStorage.getItem(
      BETALNINGSUPPGIFT_REMINDER_PENDING_KEY,
    );

    sessionStorage.removeItem(BETALNINGSUPPGIFT_REMINDER_PENDING_KEY);
    if (!paymentDetailsReminderPending) {
      return;
    }

    combineLatest([
      this.authService.getIdTokenClaim('bedomareId'),
      this.authService.getIdTokenClaim('isForordnad'),
    ])
      .pipe(
        take(1),
        switchMap(([bedomareId, isForordnad]) => {
          if (!bedomareId || !isForordnad) {
            return EMPTY;
          }
          return this.http
            .get<{
              harBetalningsuppgifter: boolean;
            }>(
              `${this.env.etjansterCommonApiUrl}/betalningsuppgifter/${bedomareId}`,
            )
            .pipe(take(1));
        }),
      )
      .subscribe((res) => {
        if (res && res.harBetalningsuppgifter) {
          return;
        }
        this.modalService.show(BetalningsuppgiftReminderModalComponent);
      });
  }
}
